import styled from '@emotion/styled';
import * as MUI from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Button = styled(MUI.IconButton)`
  cursor: pointer;
`;

export const EditButton = styled(MUI.IconButton)`
  cursor: pointer;
  & :hover {
    color: green;
  }
`;

export const DeleteButton = styled(MUI.IconButton)`
  cursor: pointer;
  & :hover {
    color: red;
  }
`;
